/**
 * App Config Slice
 *
 * Zustand slice for deployment-level config: countryId and clientId from
 * GET /v1/public/country-by-origin. Populated by AppConfigProvider on bootstrap.
 */

import type { SliceCreator, AppConfigSlice, AppConfigSliceState } from '../types';

// ============================================================================
// Initial State
// ============================================================================

export const appConfigSliceInitialState: AppConfigSliceState = {
  countryId: null,
  clientId: null,
  countryName: null,
  clientName: null,
  defaultPhoneCountry: null,
  allowedPhoneCountries: null,
  appConfigReady: false,
};

// ============================================================================
// Slice Creator
// ============================================================================

export const createAppConfigSlice: SliceCreator<AppConfigSlice> = (set) => ({
  ...appConfigSliceInitialState,

  setAppConfig: (config) => {
    set(
      {
        countryId: config.countryId,
        clientId: config.clientId,
        countryName: config.countryName ?? null,
        clientName: config.clientName ?? null,
        defaultPhoneCountry: config.defaultPhoneCountry ?? null,
        allowedPhoneCountries: config.allowedPhoneCountries ?? null,
        appConfigReady: true,
      },
      false,
      'appConfig/set'
    );
  },
});
